var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileyDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2579_1303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.5771 11.4229C59.2111 4.05673 49.4173 0 39.0001 0C32.4608 0 26.0893 1.61702 20.4305 4.69248L18.3167 1.12128C17.9052 0.425966 17.1576 0 16.3502 0H16.3392C15.5278 0.00396105 14.7793 0.437849 14.3727 1.14017L7.29748 13.359C6.53665 14.6728 5.83814 16.1937 5.87699 18.4058C2.03004 24.5537 0 31.6569 0 39.0001C0 49.4173 4.05673 59.211 11.4229 66.5772C18.7891 73.9434 28.5828 78.0002 39.0001 78.0002C49.4173 78.0002 59.211 73.9434 66.5772 66.5772C73.9434 59.211 78.0002 49.4173 78.0002 39.0001C78 28.5827 73.9433 18.789 66.5771 11.4229ZM11.2526 15.6492L16.3719 6.80829L21.5055 15.4816C22.0879 16.4656 22.3108 17.1792 22.3279 18.1142C22.3874 21.3898 19.771 24.1033 16.4954 24.163C14.9083 24.1924 13.4054 23.6012 12.2631 22.4995C11.1207 21.3979 10.4756 19.9174 10.4465 18.3304C10.4293 17.3845 10.6252 16.7329 11.2526 15.6492ZM63.3453 63.3453C56.8423 69.8483 48.1964 73.4296 38.9999 73.4296C29.8036 73.4296 21.1575 69.8483 14.6545 63.3453C8.15185 56.8425 4.57045 48.1964 4.57045 39.0001C4.57045 33.8733 5.69066 28.8817 7.83603 24.337C8.20639 24.8526 8.62382 25.3398 9.09062 25.7898C11.0647 27.6934 13.647 28.7347 16.382 28.7347C16.4474 28.7347 16.513 28.7341 16.5785 28.7329C22.3739 28.6273 27.003 23.8265 26.8972 18.0312C26.866 16.3096 26.4161 14.8054 25.4383 13.1537L22.7598 8.62824C27.7132 5.96809 33.2824 4.57045 39.0001 4.57045C48.1966 4.57045 56.8425 8.1517 63.3455 14.6547C69.8485 21.1575 73.4296 29.8036 73.4296 39.0001C73.4296 48.1966 69.8483 56.8425 63.3453 63.3453Z",
    fill: "url(#paint0_linear_2579_1303)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9913 50.8872C34.3383 50.8872 30.0274 53.4879 27.741 57.6743C27.136 58.782 27.5437 60.1704 28.6514 60.7752C29.7588 61.38 31.1473 60.9725 31.7523 59.8649C33.2369 57.1463 36.0107 55.4575 38.9913 55.4575C41.9857 55.4575 44.766 57.1582 46.2472 59.8959C46.6608 60.6603 47.4471 61.0942 48.2592 61.0941C48.6262 61.0941 48.9989 61.0053 49.3446 60.8183C50.4546 60.2178 50.8676 58.8311 50.2672 57.7209C47.9865 53.5058 43.6659 50.8872 38.9913 50.8872Z",
    fill: "url(#paint1_linear_2579_1303)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5624 38.2474C28.5624 39.5094 29.5855 40.5326 30.8476 40.5326C32.1096 40.5326 33.1328 39.5094 33.1328 38.2474C33.1328 33.9087 29.6037 30.3789 25.2655 30.3789C20.9276 30.3789 17.3984 33.9087 17.3984 38.2474C17.3984 39.5094 18.4216 40.5326 19.6837 40.5326C20.9457 40.5326 21.9689 39.5094 21.9689 38.2474C21.9689 36.4288 23.4477 34.9494 25.2655 34.9494C27.0835 34.9494 28.5624 36.429 28.5624 38.2474Z",
    fill: "url(#paint2_linear_2579_1303)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7384 30.3789C48.4002 30.3789 44.8711 33.9087 44.8711 38.2474C44.8711 39.5094 45.8943 40.5326 47.1563 40.5326C48.4184 40.5326 49.4415 39.5094 49.4415 38.2474C49.4415 36.4288 50.9204 34.9494 52.7384 34.9494C54.5562 34.9494 56.035 36.4288 56.035 38.2474C56.035 39.5094 57.0582 40.5326 58.3202 40.5326C59.5823 40.5326 60.6055 39.5094 60.6055 38.2474C60.6053 33.9087 57.0762 30.3789 52.7384 30.3789Z",
    fill: "url(#paint3_linear_2579_1303)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2579_1303",
    x1: 0,
    y1: 39.0001,
    x2: 78.0002,
    y2: 39.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3154C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2579_1303",
    x1: 27.4609,
    y1: 55.9906,
    x2: 50.5428,
    y2: 55.9906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3154C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2579_1303",
    x1: 17.3984,
    y1: 35.4558,
    x2: 33.1328,
    y2: 35.4558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3154C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2579_1303",
    x1: 44.8711,
    y1: 35.4558,
    x2: 60.6055,
    y2: 35.4558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3154C8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2579_1303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyDown);
export default __webpack_public_path__ + "static/media/smiley-down.13c3c645a1a686e6ecdd5e16dce229f8.svg";
export { ForwardRef as ReactComponent };